import { ProjectDashboardFiltersStore } from '@store/zustand/project-dashboard-filters/types';
import { create } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

const useProjectDashboardFiltersStore = create<ProjectDashboardFiltersStore>(
  (set, get) => ({
    partners: [],
    selectedPartner: null,

    setPartners: (partners) => {
      const { selectedPartner, partners: oldPartners } = get();

      const isCurrentSelectedPartnerExist =
        !selectedPartner || partners.includes(selectedPartner);

      const isPartnerAdded = oldPartners.length < partners.length;

      set({
        partners,
        selectedPartner:
          isPartnerAdded || !isCurrentSelectedPartnerExist
            ? partners[partners.length - 1]
            : selectedPartner,
      });
    },

    removePartner: (partner) => {
      const { partners, selectedPartner } = get();

      if (!partners.includes(partner)) {
        return;
      }

      const updatedPartners = partners.filter((p) => p !== partner);
      let newSelectedPartner = selectedPartner;

      if (selectedPartner === partner) {
        newSelectedPartner =
          updatedPartners.length > 0 ? updatedPartners[0] : null;
      }

      set({
        partners: updatedPartners,
        selectedPartner: newSelectedPartner,
      });
    },

    setSelectedPartner: (partner) => {
      const currentPartners = get().partners;

      if (partner && currentPartners.includes(partner)) {
        set({ selectedPartner: partner });
      }
    },

    isSelectedPartner: (partner) => {
      const { selectedPartner } = get();
      return selectedPartner === partner;
    },

    clearDashboardFilters: () => set({ partners: [], selectedPartner: null }),
  }),
);

export const useProjectDashboardFilters = () =>
  useProjectDashboardFiltersStore(
    useShallow(({ partners, selectedPartner }) => ({
      partners,
      selectedPartner,
    })),
  );

export const useProjectDashboardActions = () =>
  useProjectDashboardFiltersStore(
    useShallow(
      ({
        setPartners,
        setSelectedPartner,
        removePartner,
        isSelectedPartner,
        clearDashboardFilters,
      }) => ({
        setPartners,
        setSelectedPartner,
        removePartner,
        isSelectedPartner,
        clearDashboardFilters,
      }),
    ),
  );

export default useProjectDashboardFiltersStore;
